<div class="modal-container">
  <div class="modal-header">
    <h5 class="header-title">Credentials</h5>
  </div>

  <div class="modal-body">
    <div class="w-100 d-flex">
      <!-- CREDENTIALS TOOL -->
      <div class="w-50 pe-4 border-end">
        <div class="">
          <div class="mb-3 d-flex justify-content-between">
            <h6 class="body-title form-check-label" for="credential-switch">Enable</h6>
            <div class="form-check form-switch">
              <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="credential-switch"
                (click)="onDisable()" [(ngModel)]="credentialsToolEnabled" [checked]="credentialsToolEnabled" />
            </div>
          </div>
          <!-- NEW USER CREATION -->
          <div *ngIf="credentialsToolEnabled && !this.isAddingCredentials">
            <button class="btn-action mx-auto" (click)="this.isAddingCredentials = true">
              New User
            </button>
          </div>
          <div *ngIf="credentialsToolEnabled && this.isAddingCredentials">
            <div class="content-form">
              <div class="mb-2">
                <p class="text-center">Creating new credentials</p>
              </div>
              <div class="form-group m-0">
                <div class="form-field">
                  <label for="username">User:</label>
                  <input class="input-wrapper" type="text" id="username" [(ngModel)]="newCredentials.username" />
                </div>
                <div class="form-field mb-2">
                  <label for="password">Password:</label>
                  <input class="input-wrapper" type="text" id="password" [(ngModel)]="newCredentials.password" />
                </div>
                <button class="btn-action ms-auto mb-3" (click)="generatePassword()">Generate password</button>
              </div>
              <div class="d-flex justify-content-center">
                <button class="btn-sm-gray me-2" (click)="onCancel('new')">Cancel</button>
                <button class="btn-sm-green" (click)="onSubmit('new')" [disabled]="!newCredentials">Create</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- USERS LIST -->
      <div class="w-50 ps-4">
        <!-- <div class="w-75 m-auto"> -->
        <h6 class="body-title mb-3">Registering Users</h6>
        <div *ngIf="credentialsToolEnabled && !isEditingCredentials && !isDeletingCredentials"
          class="credentials-list overflow-auto">
          <div *ngFor="let credentials of credentialsList"
            class="mb-3 d-flex justify-content-between align-items-center">
            <div>
              <p>
                <span class="me-2" *ngIf="credentials.is_admin"><i class="fa fa-star"></i></span>
                <span>{{ credentials.username }}</span>
                <span *ngIf="credentials.is_admin"> / M0B1L3M3D142023*</span>
              </p>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <!-- <button class="btn-secondary-action-lil mb-1 me-1">Editar</button>
                  <button class="btn-secondary-action-lil me-1">Eliminar</button> -->
              <button *ngIf="!credentials.is_admin" title="Editar credenciales" class="action-btn-lil"
                (click)="editUserCeredentials(credentials)">
                <img id="edit" alt="edit icon" />
              </button>
              <button *ngIf="!credentials.is_admin" type="button" class="action-btn-lil" title="Eliminar credenciales"
                (click)="deleteUserCeredentials(credentials)">
                <img src="/assets/img/tools/delete.svg" class="svg-toblack" alt="delete icon" />
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="credentialsToolEnabled && isEditingCredentials">
          <div class="mb-2">
            <p class="text-center">
              Editing:
              <span class="fw-bolder">{{ editionOldUsername }}</span>
            </p>
          </div>
          <div>
            <div class="mb-2 d-flex align-items-center">
              <label class="me-2" for="username">User:</label>
              <input class="custom-input m-0" type="text" id="username" [(ngModel)]="editionCredentials.username" />
            </div>
            <div class="mb-2 d-flex align-items-center">
              <label class="me-2" for="password">Password:</label>
              <input class="custom-input m-0" type="text" id="password" [(ngModel)]="editionCredentials.password" />
              <button class="ms-2 btn-action" (click)="generatePassword()">Generate</button>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button class="cancel-btn" (click)="onCancel('edit')">Cancel</button>
            <button class="confirm-btn" (click)="onSubmit('edit')"
              [disabled]="!editionCredentials.username && !editionCredentials.password">
              Update
            </button>
          </div>
        </div>

        <div *ngIf="credentialsToolEnabled && isDeletingCredentials">
          <div class="mb-2">
            <p class="text-center">
              Deleting:
              <span class="fw-bolder">{{ deletionUsername }}</span>
            </p>
          </div>
          <div class="mb-2">
            <p>Are you sure you want to delete these credentials?</p>
          </div>
          <div class="d-flex justify-content-center">
            <button class="cancel-btn" (click)="onCancel('delete')">No, cancel</button>
            <button class="confirm-btn" (click)="onSubmit('delete')">Yes, delete</button>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" (click)="onDismiss('cancel')">Cancel</button>
    <button class="btn-main" (click)="onConfirm()">Confirm</button>
  </div>

  <!-- <button type="button" class=" text-secondary" (click)="onDismiss('cancel')" data-dismiss="modal">
    <span class="ti ti-close"></span>
  </button> -->
</div>